export const FETCH_LOCATIONS_REQUESTED = 'FETCH_LOCATIONS_REQUESTED';
export const FETCH_LOCATIONS_SUCCEEDED = 'FETCH_LOCATIONS_SUCCEEDED';
export const FETCH_LOCATION_BY_DESTINATION_ID_REQUESTED = 'FETCH_LOCATION_BY_DESTINATION_CODE_REQUESTED';
export const FETCH_LOCATION_BY_DESTINATION_ID_SUCCEEDED = 'FETCH_LOCATION_BY_DESTINATION_CODE_SUCCEEDED';
export const DELETE_LOCATION_REQUESTED = 'DELETE_LOCATION_REQUESTED';
export const DELETE_LOCATION_SUCCEEDED = 'DELETE_LOCATION_SUCCEEDED';
export const MAP_DESTINATION_TO_LOCATION = 'MAP_DESTINATION_TO_LOCATION';
export const LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER = 'LOCATION_COMPONENT_UPDATE_DESTINATION_FILTER';
export const PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER = 'PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER';
